import styled from "@emotion/styled";
import React from "react";
// import icon from "../images/icon.png";
import icon from "../images/icon.jpeg";
import close from "../images/close.png";
import useAppStore from "../appStore";
import { motion } from "framer-motion";
const variants = {
  open: { rotate: 90 },
  closed: { rotate: 0 },
};
const ChatButton = () => {
  const chatOpen = useAppStore((state) => state.chatOpen);
  const setChatOpen = useAppStore((state) => state.setChatOpen);
  function handleChatClick() {
    setChatOpen(!chatOpen);
  }
  return (
    <StyledChatButton
      id="chat-button"
      initial="closed"
      animate={chatOpen ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.2 }}
      onClick={handleChatClick}
      tabIndex={0}
    >
      {!chatOpen && <Avatar draggable={false} alt="icon" src={icon} />}
      {chatOpen && <CloseIcon draggable={false} alt="close" src={close} />}
    </StyledChatButton>
  );
};

const StyledChatButton = styled(motion.button)`
  height: 50px;
  width: 50px;
  border-radius: 10px;
  pointer-events: all !important;
  background: ${({ theme }) => theme.colors.primary};
  position: relative;
  scale: 1;
  transition: scale 0.2s ease-in-out;
  user-select: none;
  &:hover {
    scale: 1.02;
  }
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export default ChatButton;
